export default "__VITE_ASSET__Dr4vX9x3__"